import { render, staticRenderFns } from "./CQDraggableDots.vue?vue&type=template&id=c99cd45e&scoped=true&"
var script = {}
import style0 from "./CQDraggableDots.vue?vue&type=style&index=0&id=c99cd45e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99cd45e",
  null
  
)

export default component.exports